import { render, staticRenderFns } from "./index.vue?vue&type=template&id=464ddd8d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=464ddd8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/app/components/img.vue').default,CategoryCards: require('/app/components/category/cards.vue').default,Title: require('/app/components/title.vue').default,Img: require('/app/components/img.vue').default})
